import { Module } from './base';
import { getTranslation } from "../components/i18n";
import SettingsPersistor from "../components/settings-persistor";

class ContrastModesModule implements Module {
  name = 'contrast-modes';

  modes = ['default', 'grayscale', 'inverted', 'high-contrast'];

  setup(a11ySettings: Record<string, any>, modulesContainer: HTMLElement) {
    const moduleName = this.name;
    let styleContents = `
      #contrast-modes-wrapper {
        position: fixed;
        width: 200vw;
        height: 200vh;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
        z-index: var(--a11y-z-index);
      }
      .a11y-contrast-mode-grayscale {
        #contrast-modes-wrapper {
          backdrop-filter: grayscale(1);
        }
      }
      .a11y-contrast-mode-inverted {
        #contrast-modes-wrapper {
          backdrop-filter: invert(1);
        }
      }
    `;
    const contrastModeElement = document.createElement("div");
    contrastModeElement.className = `a11y-module a11y-module-${moduleName}`;
    contrastModeElement.innerHTML = `
      <label id="a11y-${moduleName}-label" for="a11y-${moduleName}" data-translation-field="true" data-translation-key="contrastMode">${getTranslation('contrastMode')}</label>
      <select id="a11y-${moduleName}">
        <option value="default" data-translation-field="true" data-translation-key="contrastNormal">${getTranslation('contrastNormal')}</option>
        <option value="grayscale" data-translation-field="true" data-translation-key="contrastGrayscale">${getTranslation('contrastGrayscale')}</option>
        <option value="inverted" data-translation-field="true" data-translation-key="contrastInverted">${getTranslation('contrastInverted')}</option>
        <option value="high-contrast" data-translation-field="true" data-translation-key="contrastHigh">${getTranslation('contrastHigh')}</option>
      </select>
    `;
    modulesContainer.appendChild(contrastModeElement);
    const contrastModeWrapper = document.createElement("div");
    contrastModeWrapper.className = `${moduleName}-wrapper`;
    contrastModeWrapper.id = `${moduleName}-wrapper`;
    document.body.appendChild(contrastModeWrapper);
    const changeMode = (mode: string) => {
      const contrastModeWrapper = document.getElementById(`${moduleName}-wrapper`);
      if (contrastModeWrapper) {
        this.modes.forEach((mode) => {
          if (document.body.classList.contains(`a11y-contrast-mode-${mode}`)) {
            document.body.classList.remove(`a11y-contrast-mode-${mode}`);
          }
        });
        document.body.classList.add(`a11y-contrast-mode-${mode}`);
      }
    };
    const contrastModeSelect = document.getElementById(`a11y-${moduleName}`) as HTMLInputElement;
    contrastModeSelect?.addEventListener("change", () => {
      changeMode(contrastModeSelect.value);
      SettingsPersistor.save(moduleName, contrastModeSelect.value);
    });
    if (a11ySettings[moduleName]) {
      contrastModeSelect.value = a11ySettings[moduleName];
      changeMode(contrastModeSelect.value);
    }
    return styleContents;
  }

  reset() {
    const select = document.getElementById('a11y-contrast-modes') as HTMLSelectElement;
    this.modes.forEach((mode) => {
      document.body.classList.remove(`a11y-contrast-mode-${mode}`);
    });

    if (select) {
      select.value = 'default';
      select.dispatchEvent(new Event('change'));
    }
  }
}

export default new ContrastModesModule();